import { render, staticRenderFns } from "./ModalAddAudioCategoryMeditation.vue?vue&type=template&id=0b535e44&scoped=true&"
import script from "./ModalAddAudioCategoryMeditation.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudioCategoryMeditation.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudioCategoryMeditation.vue?vue&type=style&index=0&id=0b535e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b535e44",
  null
  
)

export default component.exports